// extracted by mini-css-extract-plugin
export default {"container":"steps_container__7Zegy","graphic":"steps_graphic__LjpvW","wrapper":"steps_wrapper__wyUlt"};